import { useContext } from "react";
import { ReactComponent as TaylorWimpeyLogo } from "../img/taylor-wimpey-logo.svg";
import { ReactComponent as ThresholdLogo } from "../img/threshold-logo.svg";
// FIX [eslint no-unused-vars Line 4]: Removed unused 'PersimmonLogo' import.
// Previously: import PersimmonLogo from "../img/persimmon-logo.png";
import AppContext from "../Context/AppContext";

const Header = () => {
  const { referral, trackingCode } = useContext(AppContext);

  return (
    <>
      <header className="fixed z-40 mb-8 w-full bg-white shadow-md shadow-gray-500/25">
        <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* FIX [eslint react/jsx-no-target-blank Line 15]: Added rel="noreferrer". */}
            {/* Previously: <a href={...} target="_blank"> (no rel attribute) */}
            <a
              href={`https://www.thresholdmortgages.com/?utm_source=${trackingCode}&utm_medium=web_app`}
              target="_blank"
              rel="noreferrer" // FIX: added rel="noreferrer" to prevent security risk
            >
              <ThresholdLogo />
            </a>
            {
              referral === "t" ? (
                <div className="flex h-10 items-center justify-end xs:h-12">
                  <TaylorWimpeyLogo />
                </div>
              ) : referral === "p" ? null : null // </div> //   <img className="h-10 xs:h-14" src={PersimmonLogo} alt="" /> // <div className="flex items-center justify-end">
            }
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
